import { render, staticRenderFns } from "./AiReportInterviewDetailsCard.vue?vue&type=template&id=406d25c0&scoped=true"
import script from "./AiReportInterviewDetailsCard.vue?vue&type=script&lang=ts"
export * from "./AiReportInterviewDetailsCard.vue?vue&type=script&lang=ts"
import style0 from "./AiReportInterviewDetailsCard.vue?vue&type=style&index=0&id=406d25c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406d25c0",
  null
  
)

export default component.exports